<digital-platform-category-list-nav
  (itemClick)="handleItemClick($event)"
  (itemInfoClick)="handleItemInfoClick($event)"
  (dropdownClick)="handleDropdownClick($event)"
  (favoriteItemRemoved)="handleFavoriteItemRemoved($event)"
  (favoritesChanged)="handleFavoritesChanged($event)"
  [favorites]="favorites"
  [data]="data"
  [settings]="settings"
></digital-platform-category-list-nav>
